// extracted by mini-css-extract-plugin
module.exports = {"search":"search--2BlwV","search__icon":"search__icon--3_TC2","search__input":"search__input--2UiIM","serach__input":"serach__input--wShdc"};